import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';
import { signateNotificationsUnSignedInPath } from './api';
import type { SignateNotificationsResponse } from './signate_notifications_response_type';

export type SignateNotificationsUnSignedInRequest = Partial<{
  orderBy: string;
  descOrder: boolean;
  page: number;
  per: number;
}> & { targetPage: 'sign_in' };

export type SignateNotificationsUnsignedInResponse = Required<{
  signateNotifications: SignateNotificationsResponse[];
  totalCount: number;
}>;

export const getSignateNotificationsUnSignedIn = async (
  searchRequest: SignateNotificationsUnSignedInRequest
): Promise<AxiosResponse> => {
  const params = new URLSearchParams();
  params.append('targetPage', searchRequest.targetPage);
  if (searchRequest.orderBy) {
    params.append('orderBy', searchRequest.orderBy);
    params.append('descOrder', String(searchRequest.descOrder));
  }
  if (searchRequest.per) params.append('per', String(searchRequest.per));
  if (searchRequest.page) params.append('page', String(searchRequest.page));
  return await adminAxios.get(signateNotificationsUnSignedInPath(), { params });
};
